export default __webpack_public_path__ + "static/media/ohai-logo.82d6e42b.svg";